import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  makeSelectGuestOrderOrderRef,
  makeSelectIsFetchingData,
  makeSelectCanCancelTermination,
  makeSelectTerminationDetails,
  makeSelectTerminationMessageData,
  makeSelectTerminationActionType,
  makeSelectDateOptions,
  makeSelectMonthOptions,
  makeSelectYearOptions,
  makeSelectIsWinbackModalView,
  makeSelectLoggedInUserDetails,
  makeSelectTerminationPayLoad,
  makeSelectwinback,
  makeSelectSelectedWinback,
  makeSelectWinbackEligible,
  makeSelectCanRequestTerminationEligibility,
  makeSelectTermination,
  makeSelectPageValidations,
  makeSelectWorkflow,
  makeSelectEligibility
} from "ducks/selectors";
import NotEligible from "components/NotEligible";
import { forms, MANAGE_ORDER_URL_WITH_TERMINATE } from "utils/constants";
import {
  setData,
  clearData,
  requestToWinback,
  cancelTerminationNumber,
  postTerminateNumberRequest
} from "ducks/actions";
import { getDOBSecurityHeader, handleOnLoadAction } from "utils/helpers";
import get from "lodash/get";
import Spinner, { styles } from "components/Spinner";
import RequestTermination from "./RequestTermination";
import CancelTermination from "./CancelTermination";
import TerminationStatus from "./TerminationStatus";

export const TerminateNumberAction = props => {
  const {
    terminationEligible,
    isFetchingOrderDetails,
    isSubmittingTermination,
    isSubmittingWinback,
    isCancellingTermination,
    canCancelTermination,
    match,
    canRequestTerminationEligibility
  } = props;

  useEffect(() => {
    handleOnLoadAction(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const terminationStatus = get(match, "params.status", "");

  if (
    isFetchingOrderDetails ||
    isSubmittingTermination ||
    isSubmittingWinback ||
    isCancellingTermination
  ) {
    return <Spinner size={200} sx={styles.fullPage} />;
  }

  if (terminationStatus) {
    return <TerminationStatus {...props} />;
  }

  if (canCancelTermination) {
    return <CancelTermination {...props} />;
  }

  if (canRequestTerminationEligibility) {
    return <RequestTermination {...props} />;
  }

  return (
    <NotEligible
      {...terminationEligible}
      url={MANAGE_ORDER_URL_WITH_TERMINATE}
    />
  );

  // return <FormattedMessage html id="sorry_you_are_not_eligible" />;
};

const mapStateToProps = createStructuredSelector({
  orderRef: makeSelectGuestOrderOrderRef(),
  isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
  isSubmittingTermination: makeSelectIsFetchingData("submitTermination"),
  isSubmittingWinback: makeSelectIsFetchingData("submitWinback"),
  isCancellingTermination: makeSelectIsFetchingData("cancelTermination"),
  canCancelTermination: makeSelectCanCancelTermination(),
  orderDetails: makeSelectTerminationDetails(),
  terminationEligible: makeSelectEligibility(),
  messageData: makeSelectTerminationMessageData(),
  monthOptions: makeSelectMonthOptions(),
  dateOptions: makeSelectDateOptions(),
  yearOptions: makeSelectYearOptions(),
  actionType: makeSelectTerminationActionType(),
  isWinbackModalView: makeSelectIsWinbackModalView(),
  loggedInUserDetail: makeSelectLoggedInUserDetails(),
  terminationPayLoad: makeSelectTerminationPayLoad(),
  winbackOptions: makeSelectwinback(),
  rewards: makeSelectSelectedWinback(),
  winbackEligible: makeSelectWinbackEligible(),
  canRequestTerminationEligibility: makeSelectCanRequestTerminationEligibility(),
  formValues: makeSelectTermination(),
  formValidations: makeSelectPageValidations(forms.TERMINATE_NUMBER_FORM),
  workflow: makeSelectWorkflow()
});

export function mapDispatchToProps(dispatch) {
  return {
    requestWinback: navigate => {
      dispatch(
        requestToWinback(response => {
          if (!response.termination_eligibility) {
            dispatch(
              setData({
                key: "isWinbackModalView",
                data: { isWinbackModalView: false }
              })
            );
            navigate && navigate();
          }
        })
      );
      dispatch(
        setData({
          key: "isWinbackModalView",
          data: { isWinbackModalView: true }
        })
      );
    },
    showWinbackModal: () => {
      dispatch(
        setData({
          key: "isWinbackModalView",
          data: { isWinbackModalView: true }
        })
      );
    },
    cancelTermination: (params, navigate) => {
      dispatch(
        cancelTerminationNumber(params, (_, error) => {
          dispatch(
            setData({
              key: "isWinbackModalView",
              data: { isWinbackModalView: false }
            })
          );
          if (!error) {
            setTimeout(() => {
              navigate && navigate();
            }, 0);
          }
        })
      );
    },
    postTerminateNumberRequest: (headers, params, navigate) => {
      dispatch(
        postTerminateNumberRequest(headers, params, (_, error) => {
          if (!error) {
            dispatch(clearData(["order", "userOrders"]));
            setTimeout(() => {
              navigate && navigate();
            }, 0);
          }
        })
      );
      dispatch(
        setData({
          key: "isWinbackModalView",
          data: { isWinbackModalView: false }
        })
      );
    },
    hideWinbackModal: () => {
      dispatch(
        setData({
          key: "isWinbackModalView",
          data: { isWinbackModalView: false }
        })
      );
    }
  };
}
export const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  cancelTermination: navigate => {
    const { title, id } = stateProps?.rewards || {};
    if (!(title && id)) return;
    const params = {
      reward_title: title,
      reward_id: id,
      cancel_termination: false
    };
    dispatchProps.cancelTermination(params, navigate);
  },
  postTerminateNumberRequest: navigate => {
    const headers = getDOBSecurityHeader(stateProps?.formValues?.dob);
    const params = stateProps?.terminationPayLoad;
    dispatchProps.postTerminateNumberRequest(headers, params, navigate);
  },
  requestWinback: navigate => {
    dispatchProps.showWinbackModal();
    dispatchProps.requestWinback(navigate);
  },
  ignoreWinback: navigate => {
    dispatchProps.hideWinbackModal();
    navigate && navigate();
  }
});

TerminateNumberAction.defaultProps = {
  fetchOrderDetails: () => {}
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(withConnect, memo)(TerminateNumberAction);
